import {createSlice} from "@reduxjs/toolkit";
import {lumenApi} from "../../app/services/lumenApi";

const initialState = {
    user: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : {},
    isAuth: localStorage.getItem("lumenToken") ? true : false,
    lumenToken: localStorage.getItem("lumenToken")
        ? localStorage.getItem("lumenToken")
        : ""
};

export const authSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        logout(state, action) {
            // Remove only auth keys — preserve the cart (and other non-auth
            // state) so a user whose token expired can re-authenticate without
            // losing an in-progress order. localStorage.clear() would wipe
            // "cartItems" too.
            localStorage.removeItem("lumenToken");
            localStorage.removeItem("user");
            localStorage.removeItem("isAuth");
            state.user = {};
            state.isAuth = false;
            state.lumenToken = "";
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            lumenApi.endpoints.postLoginLumen.matchFulfilled,
            (state, {payload}) => {
                if (payload.user && payload.token) {
                    state.user = {...state.user, ...payload.user};
                    state.isAuth = true;
                    state.lumenToken = payload.token;
                    localStorage.setItem("user", JSON.stringify(payload.user));
                    localStorage.setItem("isAuth", true);
                    localStorage.setItem("lumenToken", payload.token);
                }
            }
        );
        builder.addMatcher(
            lumenApi.endpoints.postAdminLogin.matchFulfilled,
            (state, {payload}) => {
                if (payload.user && payload.token) {
                    state.user = {...state.user, ...payload.user};
                    state.isAuth = true;
                    state.lumenToken = payload.token;
                    localStorage.setItem("user", JSON.stringify(payload.user));
                    localStorage.setItem("isAuth", true);
                    localStorage.setItem("lumenToken", payload.token);
                }
            }
        );
        builder.addMatcher(
            lumenApi.endpoints.postReverseLogin.matchFulfilled,
            (state, {payload}) => {
                if (payload.user && payload.token) {
                    state.user = {...state.user, ...payload.user};
                    state.isAuth = true;
                    state.lumenToken = payload.token;
                    localStorage.setItem("user", JSON.stringify(payload.user));
                    localStorage.setItem("isAuth", true);
                    localStorage.setItem("lumenToken", payload.token);
                }
            }
        );
        builder.addMatcher(
            lumenApi.endpoints.getLogout.matchFulfilled,
            (state, {payload}) => {
                // Preserve the cart on logout (see logout() reducer above).
                localStorage.removeItem("lumenToken");
                localStorage.removeItem("user");
                localStorage.removeItem("isAuth");
                return {user: {}, isAuth: false, lumenToken: ""};
            }
        );
    },
});
export default authSlice.reducer;

export const {logout} = authSlice.actions;

export const authSelector = (state) => state.auth;
